import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Link from "../Link";
import { productFeatureList } from "../TopAppBar";
import YouTubeIcon from "../../../images/v2/connect-with-us/youtube.svg";
import telegramLogo from "../../../images/v2/connect-with-us/telegramLogo.svg";
import FacebookIcon from "../../../images/v2/connect-with-us/facebook.svg";
import LinkedInIcon from "../../../images/v2/connect-with-us/linkedin.svg";
import SalesCommunityIcon from "../../../images/v2/connect-with-us/salescommunity.svg";
import MediumIcon from "../../../images/v2/connect-with-us/medium.svg";
import instagramIcon from "../../../images/v2/connect-with-us/Instagram.svg";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import useWidth from "../../../hooks/useWidth";

import companyLogoLight from "../../../../src/images/v4/logos/companyLogoLight.svg";
import getExtentionLogo from "../../../../src/images/v4/logos/getExtentionLogo.svg";
import metaPartnerIcon from "../../../../src/images/v4/logos/metaPartnerIcon.svg";
import appleButton from "../../../images/v4/homepage/images/appleButton.svg";
import playButton from "../../../images/v4/homepage/images/playButton.svg";
import footerImg1 from "../../../images/v2/aams_logo.webp";
import footerImg2 from "../../../images/v2/ncss_logo.webp";
import brochureQRcode from "../../../images/v4/footerIcons/BrochureQRcode.webp";
import footerImg3 from "../../../images/v2/sgTech_logo.webp";
import footerImg4 from "../../../images/v2/ace_logo.webp";

import facebookSocialIcon from "../../../images/v4/footerIcons/facebookSocialIcon.svg";
import xSocialIcon from "../../../images/v4/footerIcons/xSocialIcon.svg";
import instaSocialIcon from "../../../images/v4/footerIcons/instaSocialIcon.svg";
import linkdinSocialIcon from "../../../images/v4/footerIcons/linkdinSocialIcon.svg";
import mediumSocialIcon from "../../../images/v4/footerIcons/mediumSocialIcon.svg";
import salesSocialIcon from "../../../images/v4/footerIcons/salesSocialIcon.svg";
import telegramSocialIcon from "../../../images/v4/footerIcons/telegramSocialIcon.svg";
import youtubeSocialIcon from "../../../images/v4/footerIcons/youtubeSocialIcon.svg";
import weChatSocialIcon from "../../../images/v4/footerIcons/weChatSocialIcon.svg";
import footerLockuplogo from "../../../images/v4/footerIcons/footerLockupLogo.png";
import footerCertificateImg from "../../../images/v4/footerIcons/footerCertificateImg.png";
import transformationImg from "../../../images/v4/footerIcons/TransformationImg.png";
import copyIcon from "../../../images/v4/footerIcons/copyIcon.svg";
import closeIcon from "../../../images/v4/footerIcons/closeIcon.svg";
import qrCode from "../../../images/v4/footerIcons/qrCode.png";
import weChatIcon from "../../../images/v4/footerIcons/weChatIcon.png";

import chatIcon from "../../../images/v4/footerIcons/chatIcon.svg";
import closeChatIcon from "../../../images/v4/footerIcons/closeChatIcon.svg";

import fixedMenuEmailIcon from "../../../images/v4/footerIcons/fixedMenuEmailIcon.svg";
import fixedMenuInstaIcon from "../../../images/v4/footerIcons/fixedMenuInstaIcon.svg";
import fixedMenuTelegramIcon from "../../../images/v4/footerIcons/fixedMenuTelegramIcon.svg";
import fixedMenuWechatIcon from "../../../images/v4/footerIcons/fixedMenuWechatIcon.svg";
import fixedMenuWhatsappIcon from "../../../images/v4/footerIcons/fixedMenuWhatsappIcon.svg";
import fixedMenuMessangerIcon from "../../../images/v4/footerIcons/fixedMenuMessangerIcon.svg";

export const FooterLink = (props) => (
   <>
      <Box
         alignItems="center"
         color="#000 !important"
         component={Link}
         display="flex"
         fontSize="body1.fontSize"
         key={props.title}
         mb={"16px !important"}
         to={props.path}
         {...(props.alt ? { alt: props.alt } : {})}
      >
         {/*{props.icon && <props.icon />}*/}
         {props.icon && (
            <Box
               alignItems="center"
               display="flex"
               justifyContent="center"
               // width="30px"
            >
               <Box
                  alt={props.title}
                  component={"img"}
                  mr={1}
                  src={props.icon}
                  width={props.width}
               />
            </Box>
         )}
         {props.title}
      </Box>
   </>
);

FooterLink.propTypes = {
   title: PropTypes.string,
   path: PropTypes.string,
   alt: PropTypes.string,
   icon: PropTypes.any,
   width: PropTypes.any,
};

const useStyles = makeStyles((theme) => ({
   SmeStyling: {
      width: "100%",
      marginLeft: "10px",
      [theme.breakpoints.down("sm")]: {
         marginLeft: 0,
         marginTop: "10px",
         textAlign: "center",
      },
   },
   smeFooterText: {
      [theme.breakpoints.down("sm")]: {
         fontSize: "14px",
         textAlign: "center",
      },
   },
   chromeIcon: {
      maxWidth: "250px",
   },

   socialLink: {
      marginRight: theme.spacing(1),
      color: "#516f90",
   },
   countrySymbol: {
      borderRadius: "50%",
   },
   memberOf: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gridColumnGap: "30px",
      paddingLeft: "20px",
      borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
      [theme.breakpoints.down("sm")]: {
         // display: "inline-block",
         borderLeft: "none",
         marginTop: "20px",
         paddingLeft: "0px",
         paddingTop: "20px",
         borderTop: "1px solid rgba(0, 0, 0, 0.12)",
         display: "flex",
         flexDirection: "row",
         flexWrap: "wrap",
         alignItems: "center",
         justifyContent: "space-between",
         marginLeft: "0px",
      },
   },
   logoLink: {
      [theme.breakpoints.down("sm")]: {
         marginTop: "10px",
      },
   },
   aamslogoLink: {
      height: "32px",
      width: "109px",
      marginLeft: "30px",
      [theme.breakpoints.down("sm")]: {
         marginLeft: "5px",
      },
   },
   copyText: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("sm")]: {
         display: "inline-block",
      },
   },
   copyTextItem: {
      display: "flex",
      [theme.breakpoints.down("sm")]: {
         display: "inline-block",
      },
   },
   hrLeftLine: {
      width: "43%",
      height: "0px",
      marginLeft: "0px",
      marginRight: "10px",
      marginTop: "1px",
   },
   memberSupported: {
      clear: "both",
      display: "inline-block",
      overflow: "visible",
      whiteSpace: "nowrap",
      marginTop: "-10px",
   },
   hrRightLine: {
      width: "43%",
      height: "0px",
      marginRight: "0px",
      marginLeft: "10px",
      marginTop: "1px",
   },
   footerlinklist: {
      color: "#000 !impotant",
   },
   brochureQrImg: {
      display: "block",
      marginTop: "18px",
   },
   footerSmg: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
      },
      [theme.breakpoints.down("xs")]: {
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
      },
   },
   footerSmgImg: {
      width: "50%",
      height: "auto",
      [theme.breakpoints.down("sm")]: {
         maxWidth: "100%",
      },
      [theme.breakpoints.down("xs")]: {
         maxWidth: "220px",
      },
   },
   sgImg: {
      marginTop: "18px",
      [theme.breakpoints.down("xs")]: {
         height: "71px",
         width: "188px",
         marginTop: "-3px",
      },
   },
   sgTechImg: {
      [theme.breakpoints.down("xs")]: {
         height: "29px",
         width: "197px",
         marginLeft: "5px",
         marginTop: "-10px",
      },
   },
   aceImg: {
      marginTop: "24px",
      [theme.breakpoints.down("xs")]: {
         height: "55px",
         width: "83px",
         marginTop: "8px",
      },
   },
   ctoImg: {
      [theme.breakpoints.down("xs")]: {
         height: "32px",
         width: "177px",
         marginTop: "10px",
      },
   },
   ncssImg: {
      height: "55px",
      width: "99px",
      marginTop: "10px",
   },
   rowImages: {
      display: "flex",
      gap: theme.spacing(2),
      marginTop: "-15px",
   },
   googlePlay: {
      width: "130px",
      height: "40px",
      objectFit: "contain",
      marginTop: "40px",
      [theme.breakpoints.down("sm")]: {
         width: "100px",
         height: "30px",
      },
   },
   iOSAppStore: {
      width: "130px",
      height: "40px",
      objectFit: "contain",
      marginTop: "40px",
      [theme.breakpoints.down("sm")]: {
         width: "100px",
         height: "30px",
      },
   },
   qrScanner: {
      width: "90px",
      height: "90px",
      objectFit: "contain",
      [theme.breakpoints.down("sm")]: {
         width: "70px",
         height: "70px",
      },
   },
   footerimgs: {
      marginTop: "-130px",
      [theme.breakpoints.down("sm")]: {
         display: "none",
      },
   },
   footerimgsSM: {
      [theme.breakpoints.up("sm")]: {
         display: "none",
      },
   },
   logoImg: {
      width: "auto",
      [theme.breakpoints.down("md")]: {
         width: "90%",
      },
   },
   logoLink: {
      width: "auto",
      [theme.breakpoints.down("sm")]: {
         width: "18%",
      },
   },

   footerContainer: {
      background:
         "transparent linear-gradient(91deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
   },
   downloadSectionButtonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "15px",
      width: "100%",
      "& img": {
         width: "100%",
      },
   },
}));

const pepperCloud = [
   {
      title: "About us",
      path: "/about/",
   },
   {
      title: "Singapore CRM",
      path: "/country/best-crm-system-singapore-for-small-businesses/",
   },
   {
      title: "Partner with us",
      path: "/become-crm-partner",
   },
   {
      title: "Careers",
      path: "/careers/",
   },

   {
      title: "Privacy policy",
      path: "/privacy/",
   },
   {
      title: "Case studies",
      path: "/crm-case-studies/",
   },
   {
      title: "Testimonials",
      path: "/crm-testimonials/",
   },
   {
      title: "Terms of service",
      path: "/terms-of-service/",
   },
];

const pricing = [
   {
      title: "Pricing plans",
      path: "/crm-platfrom-pricing/",
   },
   {
      title: "Avail grant",
      path: "/business-grant/",
   },
   {
      title: "Mastercard offer",
      new: true,
      path: "/ai-whatsapp-crm-with-exclusive-mastercard-offer",
   },
];
const whatsappTools = [
   {
      title: "WhatsApp chat link generator ",
      path: "/whatsapp-crm-features/free-whatsapp-link-generator",
   },
   {
      title: "WhatsApp QR code generator",
      path: "/whatsapp-crm-features/free-whatsapp-qr-code-generator",
   },
   {
      title: "WhatsApp chat button generator",
      path: "/whatsapp-crm-features/free-whatsapp–click-to-live-chat-button-widget-generator/",
   },
];

const ProductUpdate = [
   {
      title: "Feature highlights",
      path: "/pepper-cloud-crm-feature-walkaround/",
      new: true,
   },
   {
      title: "Blog",
      path: "https://blog.peppercloud.com/",
   },
   {
      title: "Integrations",
      path: "/crm-integrations",
   },
   {
      title: "Product videos",
      path: "https://www.youtube.com/channel/UCZEdLzIpORF29VuemXUn5NQ",
   },
   {
      title: "Singapore grant",
      path: "https://blog.peppercloud.com/a-guide-to-singapore-government-grants/",
   },
   // {
   //   title: "EDG Grant",
   //   path: "https://blog.peppercloud.com/an-overview-of-enterprise-development-grant-edg/",
   // },
   // {
   //   title: "Business Grant",
   //   path: "https://blog.peppercloud.com/ultimate-guide-to-productivity-solutions-grant/",
   // },
   // {
   //   title: "Sales Book Synopsis",
   //   path: "https://blog.peppercloud.com/tag/sales-book-synopsis/",
   // },
   {
      title: "Product updates",
      path: "https://blog.peppercloud.com/tag/product-update/",
   },
   {
      title: "FAQs",
      path: "/crm-faq/",
   },
   {
      title: "Brochure",
      path: "/brochure.pdf",
      download: "Brochure.pdf",
   },
];

const social = [
   {
      title: "Sales Community",
      path: "https://www.facebook.com/groups/peppercloudsalescommunity",
      icon: SalesCommunityIcon,
      width: "16px",
      alt: "Sales community",
   },
   {
      title: "Facebook",
      path: "https://www.facebook.com/PepperCloudCRM",
      icon: FacebookIcon,
      width: "8px",
      alt: "Facebook page",
   },
   {
      title: "Instagram",
      path: "https://www.instagram.com/pepper.cloud/",
      icon: instagramIcon,
      width: "12px",
      alt: "Instagram +PC page",
   },
   {
      title: "LinkedIn",
      path: "https://www.linkedin.com/company/peppercloud/",
      icon: LinkedInIcon,
      width: "12px",
      alt: "LinkedIn",
   },
   {
      title: "YouTube",
      path: "https://www.youtube.com/channel/UCZEdLzIpORF29VuemXUn5NQ",
      icon: YouTubeIcon,
      width: "12px",
      alt: "Youtube +PC page",
   },
   {
      title: "Telegram",
      path: "https://t.me/peppercloudbot",
      icon: telegramLogo,
      width: "12px",
      alt: "Telegram +PC page",
   },
   {
      title: "Medium",
      path: "https://medium.com/@peppercloud",
      icon: MediumIcon,
      width: "12px",
      alt: "Medium +PC page",
   },
];
export const FeatureList = [
   {
      title: "WhatsApp CRM",
      description:
         "Integrate with WhatsApp and close deals right from your CRM.",
      path: "/whatsapp-crm/",
   },
   {
      title: "AI CRM",
      description:
         "Integrate with WhatsApp and close deals right from your CRM.",
      path: "/sales-crm-features/ai-crm-tool-for-small-business/",
   },
   {
      title: "Multichannel CRM",
      description: "Converse with customers from a single platform.",
      path: "/sales-crm-features/multichannel-integration-for-sales-marketing/",
   },
   {
      title: "Sales pipeline",
      description:
         "Organise your Leads and Opportunities with sales pipelines.",
      path: "/sales-pipeline-management-tool/",
   },
   {
      title: "Mobile CRM",
      description:
         "Access your CRM data anywhere with the Pepper Cloud CRM Mobile App. Get mobile CRM system for both iOS & Android.",
      path: "/best-mobile-crm-system-app-ios-android/",
   },

   {
      title: "Dashboard",
      description:
         "Track performance and sales visibility through visual dashboards.",
      path: "/sales-dashboard/",
   },

   {
      title: "Web forms",
      description: "Capture visitors into leads with customisable web forms.",
      path: "/lead-capture-generation-webform/",
   },
   {
      title: "Workflow automation",
      description: "",
      path: "/sales-crm-features/workflow-automation",
   },
   {
      title: "WhatsApp support CRM",
      description: "",
      path: "/whatsapp-crm-for-customer-support",
   },
];

const crmSolutions = [
   {
      title: "By team",
      path: "/crm-solutions-by-team",
   },
   {
      title: "By industry",
      path: "/industry",
   },
   {
      title: "By country",
      path: "/country",
   },
   {
      title: "Use based tools",
      path: "/user-based-tools/",
   },
   {
      title: "AI features",
      path: "/best-ai-crm-features/",
      new: true,
   },
];
const Footer = ({ showWidget = true }) => {
   const width = useWidth();
   const classes = useStyles();
   const [activePopup, setActivePopup] = useState(false);
   const [copied, setCopied] = useState(false);
   const [openFixedMenu, setOpenFixedMenu] = useState(false);

   const fixedMenu = [
      {
         link: "https://api.whatsapp.com/send?phone=6584063651&text=",
         img: fixedMenuWhatsappIcon,
      },
      {
         link: "https://www.facebook.com/PepperCloudCRM",
         img: fixedMenuMessangerIcon,
      },
      {
         link: "https://www.instagram.com/pepper.cloud/",
         img: fixedMenuInstaIcon,
      },
      {
         link: "https://t.me/peppercloudbot",
         img: fixedMenuTelegramIcon,
      },
      {
         img: fixedMenuWechatIcon,
      },
      {
         link: "mailto:sales@peppercloud.com",
         img: fixedMenuEmailIcon,
      },
   ];

   const copyToClipboard = () => {
      navigator.clipboard.writeText("PepperCloudCRM");
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
   };

   function scrollToTop() {
      window.scrollTo({
         top: 0,
         behavior: "smooth",
      });
   }
   return (
      <main>
         <div className={`popupContainer ${activePopup ? "active" : ""}`}>
            <div className="popupBody">
               <img
                  src={closeIcon}
                  alt="closeIcon"
                  className="closeIcon"
                  onClick={() => setActivePopup(false)}
               />
               <div className="popupBodyContainer">
                  <p className="font-32 font-wix-semibold color-black1 popupHeading">
                     Chat with us on{" "}
                     <img src={weChatIcon} alt="wechat+ peppercloud" /> WeChat
                  </p>
                  <p className="font-18 font-inter-medium color-black1">
                     Scan the QR code using WeChat. Navigate to "Discover" and
                     click "Scan".
                  </p>
                  <img src={qrCode} alt="QR Scan - Pepper Cloud" />
                  <p className="font-18 font-inter-medium color-black1">
                     Can't scan? Just search for our ID in WeChat
                  </p>
                  <div className="copyCode">
                     <p
                        className="font-18 font-wix-semibold"
                        style={{ color: "#007188" }}
                     >
                        PepperCloudCRM
                     </p>
                     <img src={copyIcon} alt="copy" onClick={copyToClipboard} />
                     <div
                        className={`tooltip font-14 font-inter-semibold font-white ${
                           copied ? "active" : ""
                        }`}
                     >
                        Copied!
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {typeof window !== "undefined" &&
            !window.location?.pathname?.includes(
               "pepper-cloud-crm-feature-walkaround",
            ) && (
               <div className={`fixedMenu ${openFixedMenu ? "active" : ""}`}>
                  <img
                     style={{ cursor: "pointer" }}
                     src={openFixedMenu ? closeChatIcon : chatIcon}
                     className="fixedChatIcon"
                     onClick={() => setOpenFixedMenu(!openFixedMenu)}
                  />
                  <div className="fixedLinkContainer">
                     {fixedMenu.map((menuItem, index) =>
                        menuItem.link ? (
                           <a
                              className="fixedLinkItem"
                              href={menuItem.link}
                              target="_blank"
                              onClick={() => setOpenFixedMenu(false)}
                           >
                              <img src={menuItem.img} />
                           </a>
                        ) : (
                           <img
                              className="fixedLinkItem"
                              src={menuItem.img}
                              onClick={() => {
                                 setActivePopup(true);
                                 setOpenFixedMenu(false);
                              }}
                           />
                        ),
                     )}
                  </div>
               </div>
            )}
         <section className={classes.footerContainer}>
            <div className="container">
               <div className="footerSectionOuter">
                  <div className="footerSectionContainer">
                     <div className="footerLeftSection">
                        <div className="footerLeftSectionHeader">
                           <img
                              src={companyLogoLight}
                              alt="Pepper Cloud - Best Sales CRM Software"
                           />
                           <p className="font-wix-regular font-14 color-black5">
                              Best AI-powered WhatsApp CRM for Sales and Support
                           </p>

                           <p className="font-wix-semibold font-14 color-black7">
                              Scan & download brochure
                              <img
                                 src={brochureQRcode}
                                 alt="Scan to download Pepper Cloud brochure"
                                 width="89"
                                 className={classes.brochureQrImg}
                                 height="89"
                              />
                           </p>
                        </div>
                     </div>
                     <div className="footerRightSection">
                        <div className="linkListContainer">
                           <p className="font-wix-semibold font-14 color-black7">
                              Company
                           </p>
                           <div className="links">
                              {pepperCloud.map((link) => (
                                 <a
                                    className="color-black5 font-wix-medium font-14"
                                    href={link.path}
                                 >
                                    {link.title}
                                 </a>
                              ))}
                           </div>
                        </div>
                        <div className="linkListContainer">
                           <p className="font-wix-semibold font-14 color-black7">
                              Features
                           </p>
                           <div className="links">
                              {FeatureList.map((link) => (
                                 <a
                                    className="color-black5 font-wix-medium font-14"
                                    href={link.path}
                                 >
                                    {link.title}
                                 </a>
                              ))}
                           </div>
                        </div>

                        <div className="linkListContainer">
                           <p className="font-wix-semibold font-14 color-black7">
                              Resources
                           </p>
                           <div className="links">
                              {ProductUpdate.map((link) => (
                                 <div>
                                    <a
                                       className="color-black5 font-wix-medium font-14"
                                       href={link.path}
                                       download={link.download}
                                    >
                                       {link.title}
                                    </a>
                                    {link.new && (
                                       <span className="newTag font-12 font-wix-semibold font-white">
                                          New
                                       </span>
                                    )}
                                 </div>
                              ))}
                           </div>
                        </div>
                        <div className="linkListContainer">
                           <p className="font-wix-semibold font-14 color-black7">
                              Contact us
                           </p>
                           <div className="links">
                              <a
                                 className="color-black5 font-wix-medium font-14"
                                 href="tel:+6597510475"
                              >
                                 Call (+65 9751 0475)
                              </a>
                              <a
                                 className="color-black5 font-wix-medium font-14"
                                 href="/contact/"
                              >
                                 {" "}
                                 Sales enquiry
                              </a>
                              <a
                                 className="color-black5 font-wix-medium font-14"
                                 href="/crm-support/"
                              >
                                 Support ticket
                              </a>
                              <a
                                 className="color-black5 font-wix-medium font-14"
                                 href="/become-crm-partner"
                              >
                                 Partnership
                              </a>
                              <a
                                 className="color-black5 font-wix-medium font-14"
                                 href="/write-for-us"
                              >
                                 Write for us
                              </a>
                           </div>
                        </div>
                        <div className="linkListContainer">
                           <p className="font-wix-semibold font-14 color-black7">
                              Free WhatsApp tools
                           </p>
                           <div className="links">
                              {whatsappTools.map((link) => (
                                 <div>
                                    <a
                                       className="color-black5 font-wix-medium font-14"
                                       href={link.path}
                                    >
                                       {link.title}
                                    </a>
                                    {/* <span className="newTag font-12 font-wix-regular font-white">
                          New
                        </span> */}
                                 </div>
                              ))}
                           </div>
                        </div>
                        <div className="linkListContainer">
                           <p className="font-wix-semibold font-14 color-black7">
                              CRM solutions
                           </p>
                           <div className="links">
                              {crmSolutions.map((link) => (
                                 <a
                                    className="color-black5 font-wix-medium font-14"
                                    href={link.path}
                                 >
                                    {link.title}
                                    {link.new && (
                                       <span className="newTag font-12 font-wix-semibold font-white">
                                          New
                                       </span>
                                    )}
                                 </a>
                              ))}
                           </div>
                        </div>
                        <div className="linkListContainer">
                           <p className="font-wix-semibold font-14 color-black7">
                              Pricing
                           </p>
                           <div className="links">
                              {pricing.map((link) => (
                                 <div>
                                    <a
                                       className="color-black5 font-wix-medium font-14"
                                       href={link.path}
                                    >
                                       {link.title}
                                    </a>
                                    {link.new && (
                                       <span className="newTag font-12 font-wix-semibold font-white">
                                          New
                                       </span>
                                    )}
                                 </div>
                              ))}
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="footerSectionRow">
                     <div className="footerLeftSectionFooter">
                        <p className="font-wix-regular font-14 font-white">
                           Partner
                        </p>

                        <img
                           src={metaPartnerIcon}
                           alt="Meta business partner - Pepper Cloud CRM"
                        />
                     </div>

                     <div className="footerRightSectionBody">
                        <div className="footerLeftSectionBody">
                           <div className="flexBox">
                              <p className="font-wix-regular font-14 font-white">
                                 Extension
                              </p>
                              <a
                                 target="_blank"
                                 href="https://chromewebstore.google.com/detail/pepper-cloud-crm-chrome-e/iccmmindhfioainhgehkhdcmapohogff"
                              >
                                 <img
                                    src={getExtentionLogo}
                                    alt="Chrome Extension - Pepper Cloud Sales CRM"
                                 />
                              </a>
                           </div>
                           <div className="flexBox">
                              <p className="font-wix-regular font-14 font-white">
                                 Download our app
                              </p>
                              <div
                                 className={
                                    classes.downloadSectionButtonContainer
                                 }
                              >
                                 <a href="https://play.google.com/store/apps/details?id=com.peppercloud">
                                    <img
                                       src={playButton}
                                       alt="Pepper Cloud Mobile CRM - Google Play"
                                    />
                                 </a>
                                 <a href="https://apps.apple.com/in/app/pepper-cloud-mobile-crm/id6499458415">
                                    <img
                                       src={appleButton}
                                       alt="Pepper Cloud Mobile CRM - iOS App Store"
                                    />
                                 </a>
                              </div>
                           </div>
                        </div>
                        <div className="socialLinks">
                           <a
                              target="_blank"
                              href="https://www.facebook.com/PepperCloudCRM"
                           >
                              <img
                                 src={facebookSocialIcon}
                                 alt="facebook + PC page"
                              />
                           </a>
                           <a
                              target="_blank"
                              href="https://www.instagram.com/pepper.cloud/"
                           >
                              <img
                                 src={instaSocialIcon}
                                 alt="Instagram + PC page"
                              />
                           </a>
                           <a
                              target="_blank"
                              href="https://x.com/peppercloudpte"
                           >
                              <img src={xSocialIcon} alt="x + PC page" />
                           </a>
                           <a
                              target="_blank"
                              href="https://www.facebook.com/groups/peppercloudsalescommunity"
                           >
                              <img
                                 src={salesSocialIcon}
                                 alt="Sales community + PC page"
                              />
                           </a>
                           <a
                              target="_blank"
                              href="https://www.linkedin.com/company/peppercloud/"
                           >
                              <img
                                 src={linkdinSocialIcon}
                                 alt="LinkedIn +PC page"
                              />
                           </a>
                           <a
                              target="_blank"
                              href="https://www.youtube.com/channel/UCZEdLzIpORF29VuemXUn5NQ"
                           >
                              <img
                                 src={youtubeSocialIcon}
                                 alt="Youtube + PC page"
                              />
                           </a>
                           <a
                              target="_blank"
                              href="https://medium.com/@peppercloud"
                           >
                              <img
                                 src={mediumSocialIcon}
                                 alt="Medium + PC page"
                              />
                           </a>
                           <a
                              target="_blank"
                              href="https://t.me/peppercloudbot"
                           >
                              <img
                                 src={telegramSocialIcon}
                                 alt="Telegram + PC page"
                              />
                           </a>
                           <img
                              src={weChatSocialIcon}
                              alt="wechat + PC page"
                              onClick={() => setActivePopup(true)}
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {/* <script>
          {showWidget && (
            <script
              dangerouslySetInnerHTML={{
                __html: `
                      var url = "https://prod-crmb2b.s3.ap-southeast-1.amazonaws.com/widget/5d70b9708f2c5d071d712b34/64378ef1569c5d0019e84ddb.js?v=" + Date.now();
                      var s = document.createElement('script');
                      s.type = 'text/javascript';
                      s.async = true;
                      s.src = url;
                      s.onload = function() {
                      CreateWhatsappChatWidget();
                      };
                      var x = document.getElementsByTagName('script')[0];
                      x.parentNode.insertBefore(s, x);
                  `,
              }}
            ></script>
          )}
        </script> */}
         </section>
         <section>
            <div className="footerContainer">
               <div className="container">
                  <div className="footerLastSectionContainer">
                     <div className="footerAwardsColumn">
                        <div className="footerLastSectionHeader">
                           <p className="color-black2 font-wix-semibold font-18">
                              Award and certification
                           </p>
                        </div>
                        <div className="footerAwardsRow">
                           <div className="footerLastSectionContainerLeft">
                              <img
                                 src={footerLockuplogo}
                                 alt={"IMDA Pre-approved Solution Provider"}
                                 className={classes.footerSmgImg}
                              />
                              <p
                                 className="font-wix-semibold"
                                 style={{ fontSize: "10px", color: "#DCE4EC" }}
                              >
                                 Pepper Cloud is awarded Google AI Trailblazers Transformation Award 2024 under a Singapore government and Google Cloud initiative
                              </p>
                           </div>
                           <img
                              src={footerCertificateImg}
                              alt="ISOCert and Cyber Essentials certified"
                              className="footerCertificateImg"
                           />
                        </div>
                     </div>
                     <br/>
                     <div className="footerMemberColumn">
                        <div className="footerLastSectionHeader">
                           <p className="color-black2 font-wix-semibold font-18">
                              Member of / Supported by
                           </p>
                        </div>
                        <div className="footerLastSectionContainerRight">
                           <div className="footerBorder" />
                           <a href="https://aams.org.sg/" target="_blank">
                              <img
                                 alt="AAMS+Pepper Cloud CRM"
                                 placeholder="blurred"
                                 src={footerImg1}
                                 className={classes.logoImg}
                              />
                           </a>
                           <a href="https://www.ncss.gov.sg/" target="_blank">
                              <img
                                 alt="NCSS+Pepper Cloud CRM"
                                 placeholder="blurred"
                                 src={footerImg2}
                                 className={classes.logoImg}
                              />
                           </a>
                           <a href="https://www.sgtech.org.sg/" target="_blank">
                              <img
                                 alt="SG Tech+Pepper Cloud CRM"
                                 placeholder="blurred"
                                 src={footerImg3}
                                 className={classes.logoImg}
                              />
                           </a>
                           <a href="https://ace.org.sg/" target="_blank">
                              <img
                                 alt="ACE+Pepper Cloud CRM"
                                 placeholder="blurred"
                                 src={footerImg4}
                                 className={classes.logoImg}
                              />
                           </a>
                        </div>
                     </div>
                  </div>
                  <div className="border" />
                  <div className="footerLastSectionBanner">
                     <p className="font-wix-medium font-14">
                        <span className="font-wix-bold">
                           © Pepper Cloud {new Date().getFullYear()}
                        </span>{" "}
                        | Best AI-powered WhatsApp Sales CRM Software Singapore
                     </p>
                     <a href="/sitemap/" className="font-wix-medium font-14">
                        Site map
                     </a>
                  </div>
               </div>
            </div>
         </section>
      </main>
   );
};

Footer.propTypes = {
   showWidget: PropTypes.boolean,
};
export default Footer;
